/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: CA
 *| (C) Copyright IBM Corp. 2022
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../utils/ShapingUIUtils'
], function({ renderJoinDialog }) {

	class GlobalRelationshipActionHandler {

		/**
		 * Determine whether the menu item should be visible or hidden
		 */
		isItemVisible(options) {
			return options.glassContext.getSvcSync('.FeatureChecker').checkValue('dashboard', 'RelationshipsView', 'enabled') ||
				!!this._getConfiguration(options.glassContext, 'showRelationships');
		}

		/**
		 * menu item selection handler
		 */
		onSelectItem(options) {
			return options.target.activeObject.dataSource.getModule().then(renderJoinDialog);
		}

		/**
		 * obtain the glass perspective app config value
		 */
		_getConfiguration(glassContext, key) {
			const perspectiveContent = glassContext.currentPerspective && glassContext.currentPerspective.getContent();
			return perspectiveContent.options.config[key];
		}
	}

	return GlobalRelationshipActionHandler;
});
